import { useEffect, useState } from 'react';
import AUX from '../../../hoc/Aux_';
import { Button, Progress } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { FaFileCsv, FaFileExcel } from 'react-icons/fa';
import { downloadXLS, downloadCSV } from '../../../helpers/helpers';
import {
  getActivityLevel,
  getActivityLevelCSV,
  getActivityLevelXLSX,
  getMember,
  getProjects,
} from '../../../redux/MainAction';
import moment from 'moment';
import { toast } from 'react-toastify';
import Select from 'react-select';

const Constant = require('../../../Constant');

const ActivityLevel = () => {
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();
  const level = useSelector((state) => state?.Webtracker?.reportsActivityLevel);
  const emp = useSelector((state) => state.Webtracker.member);
  const prj = useSelector((state) => state.Webtracker.projects);
  const [apiCalls, setApiCalls] = useState(false);
  const [showReset, setShowReset] = useState(false);
  const [dateRange, setDateRange] = useState('thisWeek');
  const [viewDate, setViewDate] = useState([]);
  const [filteredRecored, setFilteredRecord] = useState([]);

  const today = new Date();

  const dayOfWeek = today.getDay();
  const diff = dayOfWeek === 0 ? 6 : dayOfWeek - 1;

  const monday = new Date(today);
  monday.setDate(today.getDate() - diff);
  const sunday = new Date(today);
  sunday.setDate(today.getDate() + diff);

  const [filters, setFilters] = useState({
    employeeIds: [],
    projectIds: '',
    // teamIds:'',
    startDate: moment(monday).format('YYYY-MM-DD'),
    endDate: moment(today).format('YYYY-MM-DD'),
  });

  const onChangeFilter = (event) => {
    const { name, value } = event.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  const handleDateRangeChange = (e) => {
    const value = e.target.value;
    setDateRange(value);
    let start, end;
    const today = new Date();

    // Calculate the current week's Monday and Sunday
    const currentDayOfWeek = today.getDay(); // 0 (Sunday) to 6 (Saturday)
    const monday = new Date(today);
    monday.setDate(today.getDate() - currentDayOfWeek + 1); // Set to Monday of the current week
    const sunday = new Date(today);
    sunday.setDate(today.getDate() - currentDayOfWeek + 7); // Set to Sunday of the current week

    switch (value) {
      case 'thisWeek':
        start = monday;
        end = today; // End is today
        break;

      case 'last7days':
        const previousMonday = new Date(monday);
        previousMonday.setDate(monday.getDate() - 7); // Previous week's Monday
        const previousSunday = new Date(sunday);
        previousSunday.setDate(sunday.getDate() - 7); // Previous week's Sunday

        start = previousMonday;
        end = previousSunday;
        break;

      case 'last30days':
        start = new Date(Date.UTC(today.getFullYear(), today.getMonth(), 1)); // Start of the month
        end = today; // Today's date
        break;

      case 'custom':
        return;

      default:
        return;
    }

    setFilters((prev) => ({
      ...prev,
      startDate: start.toISOString().split('T')[0],
      endDate: end.toISOString().split('T')[0],
    }));
  };

  const handleEmployeeChange = (selectedOptions) => {
    const selectedIds = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setFilters((prevFilters) => ({
      ...prevFilters,
      employeeIds: selectedIds,
    }));
  };

  const employeeOptions =
    emp?.rows?.map((member) => ({
      value: member.id,
      label: `${member.firstName} ${member.lastName}`,
    })) || [];

  const dispatchCalls = async (data) => {
    await dispatch(getActivityLevel(data));
  };

  useEffect(() => {
    getList();
  }, []);

  const getList = () => {
    // const data = {
    //   entityType: 'CONTRACT',
    //   startDate: filters?.startDate,
    //   endDate: filters?.endDate,
    // };
    // dispatchCalls(data);
    dispatch(getProjects());
    dispatch(getMember());
  };

  const handleApply = async (e) => {
    e.preventDefault();
    setApiCalls(true);
    setIsLoading(true);
    if (filters?.startDate && filters?.endDate) {
      const startDate = moment(filters.startDate);
      const endDate = moment(filters.endDate);

      if (startDate.isAfter(endDate)) {
        toast.error('Start date cannot be greater than End date', {
          position: 'top-right',
        });
        return;
      }
    }
    const payload = {
      entityType: 'CONTRACT',
    };

    if (filters?.employeeIds?.length > 0) {
      payload.employeeIds = filters.employeeIds;
    }

    if (filters?.projectIds !== '') {
      payload.projectIds = [filters.projectIds];
    }
    if (filters?.startDate) {
      payload.startDate = filters.startDate;
    }

    if (filters?.endDate) {
      payload.endDate = filters.endDate;
    }
    await dispatchCalls(payload);
    setShowReset(true);
    setIsLoading(false);
  };

  const handleReset = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const data = {
      entityType: 'CONTRACT',
      startDate: moment(monday).format('YYYY-MM-DD'),
      endDate: moment(today).format('YYYY-MM-DD'),
    };
    await dispatchCalls(data);
    setDateRange('thisWeek');
    setShowReset(false);
    setFilters({
      employeeIds: [],
      projectIds: '',
      startDate: moment(monday).format('YYYY-MM-DD'),
      endDate: moment(today).format('YYYY-MM-DD'),
    });
    setDateRange('thisWeek');
    setIsLoading(false);
  };

  useEffect(() => {
    // if(dateRange==='custom'){
    const flsDate = level?.map((itm) => {
      return itm?.dates;
    })[0];
    const flsRecord = level?.map((itm) => {
      return {
        member: `${itm?.user?.firstName} ${itm?.user?.lastName}`,
        projectName: itm?.project?.name,
        dates: itm?.dates,
        averageActivity: itm?.averageActivity,
      };
    });
    setViewDate(flsDate);
    setFilteredRecord(flsRecord);
    // }
  }, [level, dateRange]);

  const dateActivityLevel = (idx, value) => `${value[idx]?.activity}%`;

  async function downloadCSVHandler(isCSV) {
    setIsLoading(true);
    const payload = {
      entityType: 'CONTRACT',
    };

    if (filters?.employeeIds?.length > 0) {
      payload.employeeIds = filters.employeeIds;
    }

    if (filters?.projectIds !== '') {
      payload.projectIds = [filters.projectIds];
    }
    if (filters?.startDate) {
      payload.startDate = filters.startDate;
    }

    if (filters?.endDate) {
      payload.endDate = filters.endDate;
    }

    if (isCSV) {
      const csv = await dispatch(getActivityLevelCSV(payload));

      downloadCSV(csv, 'Activity Levels');
    } else {
      const xlsx = await dispatch(getActivityLevelXLSX(payload));
      downloadXLS(xlsx, 'Activity Levels');
    }
    setIsLoading(false);
  }

  return (
    <AUX>
      <div className="page-content-wrapper">
        <div className="container-fluid">
          <div className="row">
            <div
              className=" d-flex align-items-center mb-2 ml-3 "
              style={{ gap: '20px' }}
            >
              <span
                className="font-14 text-primary"
                style={{ cursor: 'pointer' }}
              >
                Contract
              </span>
              <span className="font-14" style={{ cursor: 'pointer' }}>
                Members
              </span>
            </div>
            <div className="col-12">
              <div className="row">
                <div className="col-12">
                  <div className="card m-b-10">
                    <div className="d-flex flex-column card-body">
                      <div
                        className="d-flex justify-content-start align-items-start"
                        style={{ gap: '10px' }}
                      >
                        <p className="text-muted mt-2 text-nowrap">
                          Filter by :
                        </p>

                        <div className="mb-3">
                          <div className="d-flex mb-2">
                            <div className="fillSelect">
                              <i className="mdi mdi-briefcase font-20 fillIcon"></i>
                              <select
                                className="form-control font-14"
                                name="projectIds"
                                value={filters?.projectIds}
                                onChange={onChangeFilter}
                              >
                                <option value="">All Projects</option>
                                {prj?.rows?.map((mems, idx) => (
                                  <option key={idx} value={mems?.id}>
                                    {mems?.name}
                                  </option>
                                ))}
                              </select>
                            </div>

                            <div className="fillSelect">
                              <select
                                className="form-control font-14"
                                value={dateRange}
                                onChange={handleDateRangeChange}
                              >
                                <option value="custom">Custom Date</option>
                                {/* <option value="today">Today</option> */}
                                <option value="thisWeek">This Week</option>
                                <option value="last7days">Last Week</option>
                                <option value="last30days">This month</option>
                                {/* <option value="last6months">Last 6 Months</option> */}
                              </select>
                            </div>

                            {dateRange === 'custom' && (
                              <div
                                className="d-flex align-items-center font-14 ml-2"
                                style={{ gap: '5px' }}
                              >
                                <input
                                  type="date"
                                  className="form-control font-14"
                                  name="startDate"
                                  value={filters?.startDate}
                                  onChange={onChangeFilter}
                                  max={moment().format('YYYY-MM-DD')}
                                />
                                to
                                <input
                                  type="date"
                                  className="form-control font-14"
                                  name="endDate"
                                  value={filters?.endDate}
                                  onChange={onChangeFilter}
                                  max={moment().format('YYYY-MM-DD')}
                                />
                              </div>
                            )}
                          </div>

                          <div
                            className="d-flex align-items-start"
                            style={{ gap: '0.8rem' }}
                          >
                            <div className="fillSelect">
                              <i className="mdi mdi-account-multiple-outline font-20 fillIcon"></i>
                              <Select
                                isMulti
                                value={employeeOptions.filter((option) =>
                                  filters.employeeIds.includes(option.value)
                                )}
                                onChange={handleEmployeeChange}
                                options={employeeOptions}
                                placeholder="All Members"
                                className="react-select-container"
                                classNamePrefix="react-select"
                                isClearable
                                styles={{
                                  control: (provided) => ({
                                    ...provided,
                                    minHeight: '35px',
                                    height: '35px',
                                    fontSize: '14px',
                                    minWidth: '200px',
                                    minWidth: '260px',
                                    border: '1px solid #ced4da',
                                  }),
                                  valueContainer: (provided) => ({
                                    ...provided,
                                    height: '33px',
                                    padding: '0 4px',
                                    overflowY: 'auto',
                                  }),
                                  indicatorsContainer: (provided) => ({
                                    ...provided,
                                    height: '33px',
                                  }),
                                  multiValue: (provided) => ({
                                    ...provided,
                                    backgroundColor: '#e9ecef',
                                  }),
                                  multiValueLabel: (provided) => ({
                                    ...provided,
                                    fontSize: '12px',
                                  }),
                                  indicatorsContainer: (provided) => ({
                                    ...provided,
                                    height: '34px',
                                    padding: '0 4px',
                                  }),
                                }}
                              />
                            </div>

                            <div className="d-flex" style={{ gap: '10px' }}>
                              <Button
                                className="d-flex align-items-center justify-content-center"
                                style={{ padding: '6px 14px' }}
                                size="sm"
                                color="primary"
                                onClick={handleApply}
                              >
                                <i className="ion-ios7-search font-20"></i>
                              </Button>

                              {showReset ? (
                                <Button
                                  className="d-flex align-items-center justify-content-center"
                                  style={{ padding: '6px 13px' }}
                                  size="sm"
                                  color="danger"
                                  onClick={handleReset}
                                >
                                  <i className="mdi mdi-close font-20"></i>
                                </Button>
                              ) : (
                                ''
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="d-flex align-items-center justify-content-between">
                        <span>
                          <b>Note :</b> All records are displayed based on the
                          timezone set by the admin.
                        </span>

                        <div className="d-flex">
                          <Button
                            color="success"
                            size="sm"
                            className="mr-2 d-flex align-items-center"
                            onClick={() => downloadCSVHandler(true)}
                          >
                            <FaFileCsv className="mr-1" /> CSV
                          </Button>
                          {/* <Button
                            color="primary"
                            size="sm"
                            className="d-flex align-items-center"
                            onClick={() => downloadCSVHandler(true)}
                          >
                            <FaFileExcel className="mr-1" /> XLSX
                          </Button> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card m-b-20">
                <div className="card-body">
                  <div style={{ overflowX: 'auto' }}>
                    <table
                      id="datatable"
                      className="table dt-responsive nowrap table-vertical"
                      width="100%"
                      cellSpacing="0"
                    >
                      <thead>
                        <tr>
                          <th>Member</th>
                          <th>Project</th>
                          <th>Average</th>
                          {viewDate?.length > 0
                            ? viewDate?.map((itm) => (
                                <th className="text-nowrap">{itm?.date}</th>
                              ))
                            : ''}
                        </tr>
                      </thead>
                      <tbody>
                        {apiCalls ? (
                          filteredRecored?.length > 0 ? (
                            filteredRecored?.map((item, idx) => {
                              return (
                                <tr key={idx}>
                                  <td>
                                    <div className="text-nowrap">
                                      <span className="border rounded p-1 text-white bg-info text-uppercase">
                                        {item?.member.charAt(0)}
                                      </span>
                                      <span className="ml-1">
                                        {item?.member}{' '}
                                      </span>
                                    </div>
                                  </td>
                                  <td className="text-nowrap">
                                    {item?.projectName}
                                  </td>
                                  <td>
                                    <div>
                                      {' '}
                                      <Progress
                                        value={item?.averageActivity?.toFixed(
                                          2
                                        )}
                                        style={{
                                          height: '24px',
                                          fontSize: '15px',
                                        }}
                                      >
                                        <div
                                          className="progress-bar"
                                          style={{
                                            width: `${item?.averageActivity}%`,
                                            color: 'black',
                                            fontWeight: '500',
                                          }}
                                        >
                                          {item?.averageActivity
                                            ? item?.averageActivity?.toFixed(2)
                                            : 0}{' '}
                                          %
                                        </div>
                                      </Progress>
                                    </div>
                                  </td>
                                  {item &&
                                    Array.from(
                                      { length: item?.dates?.length },
                                      (_, idx) =>
                                        dateActivityLevel(idx, item?.dates)
                                    )?.map((data, index) => (
                                      <td className="text-nowrap" key={index}>
                                        {data}
                                      </td>
                                    ))}
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan="10" className="text-center">
                                No Records Found
                              </td>
                            </tr>
                          )
                        ) : (
                          <tr>
                            <td colSpan="10" className="text-center">
                              Please click on the search button.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AUX>
  );
};

export default ActivityLevel;
